import { AxiosInstance } from "axios";
import { createMaintenanceAxiosRequestInterceptor } from "shared-utils";
import { getUser } from "shared-auth";

export function createAxiosRequestInterceptors(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.request.use(
    createMaintenanceAxiosRequestInterceptor()
  );

  axiosInstance.interceptors.request.use((config) => {
    const user = getUser();

    if (config.headers && user?.access_token) {
      config.headers.Authorization = `${user?.token_type} ${user?.access_token}`;
    }

    return config;
  });
}
